import { attachmentAPIUrl } from '../api/attachments.api';

export const generateAttachmentUrl = (attachment_id: string) => {
  const url = new URL(attachmentAPIUrl);
  const attachmentURL = `${attachmentAPIUrl}/${attachment_id}`;
  return attachmentURL.replace(`${url.protocol}`, '');
};
